(function (window) {
  //   Usage:
  //   document.addEventListener(
  //     'fpsCheck',
  //     (e) => {
  //       console.log(e.detail);
  //     }
  //   );

  let pageVisible = false;

  function measureFps() {
    setTimeout(() => {
      let fps = 60;
      const times = [];

      function refreshLoop() {
        window.requestAnimationFrame(() => {
          const now = performance.now();
          times.push(now);

          // Abort measurement if page became hidden during it
          if (pageVisible === false) {
            return;
          }

          if (now - times[0] <= 1000) {
            refreshLoop();
          } else {
            fps = times.length;

            const event = new CustomEvent('fpsCheck', { detail: fps });

            // Dispatch the event.
            document.dispatchEvent(event);
          }
        });
      }
      refreshLoop();
    }, 1000);
  }

  if (document.hidden) {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        pageVisible = true;
        measureFps();
      } else {
        pageVisible = false;
      }
    });
  } else {
    pageVisible = true;
    measureFps();
  }
})(window);
